/**
 * Section-verify issues split into per-paragraph lists and the
 * section-level list shown in the banner.
 *
 * An issue whose paragraph_id names no paragraph of the section goes to
 * the section list. Filed under that id it was counted ("Verify · 1
 * issue") but shown nowhere, which is what happened when the model made
 * up ids like "spec_tf_0001".
 */
export function bucketVerifyIssues<T extends { paragraph_id?: string | null }>(
  issues: T[],
  paragraphs: Array<{ id: string }>,
): { issuesByPara: Record<string, T[]>; sectionScopedIssues: T[] } {
  const ids = new Set(paragraphs.map((p) => p.id));
  const issuesByPara: Record<string, T[]> = {};
  const sectionScopedIssues: T[] = [];
  for (const it of issues) {
    const pid = it.paragraph_id;
    if (pid && ids.has(pid)) {
      (issuesByPara[pid] ??= []).push(it);
    } else {
      sectionScopedIssues.push(it);
    }
  }
  return { issuesByPara, sectionScopedIssues };
}
